import { getConfig } from '@b2ag/micro-front-tools'
import SegmentsService from './services/segments.service'

const segmentsApiHost = getConfig('USER_API_HOST')

export const segmentsService = new SegmentsService({ segmentsApiHost })

export * from './composable/useSegments'
